module.exports = {
  HAN_DISMINUIDO: "Han disminuído",
  NO_HAN_AUMENTADO: "No han aumentado nada (siguen igual que antes)",
  HAN_AUMENTADO_POCO: "Han aumentado poco (1-25% aproximadamente)",
  HAN_AUMENTADO_BASTANTE: "Han aumentado bastante (25-50% aproximadamente)",
  HAN_AUMENTADO_MUCHO: "Han aumentado mucho (más del 50% aproximadamente)",
};
